var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNew = function SvgNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-90 10 8)",
    stroke: "currentColor",
    strokeWidth: 1.7
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.346 7.406 8.557 9.882a.571.571 0 0 1-.914.016L5.717 7.422a.571.571 0 0 1 .451-.922h3.714a.571.571 0 0 1 .464.906Z",
    strokeLinejoin: "round"
  })))));
};
export default SvgNew;